<div class="list-pagination d-flex flex-row flex-wrap justify-content-end" (keydown)="onKeyDown($event)">

    <div class="filterInput flex-fill d-flex flex-row with-gap">
        <div *ngIf="useAdditionalButtons">
            <ng-content></ng-content>
        </div>

        <div class="input-group" tabindex="-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="filter"><i class="fa fa-filter"></i></span>
            </div>
            <input type="text" class="form-control description-input" aria-label="Filter" aria-describedby="filter" [(ngModel)]="pagedDataService!.filterText" (mousedown)="$event.stopPropagation()">
            <button type="button" class="btn bg-transparent clear-button" (click)="clearFilter()" *ngIf="pagedDataService?.filterText">
                <i class="fa fa-times text-secondary"></i>
            </button>
        </div>
    </div>
    <mat-paginator
        *ngIf="pagedDataService"
        [hidden]="!pagedDataService.showPaginator"
        class="compact-mat-paginator"
        [length]="pagedDataService.filteredSortedDataLength"
        [pageSize]="pagedDataService.pageSize"
                   hidePageSize="true"></mat-paginator>
</div>
